<!-- 日期/月份选择（单日，多日） -->
<template>
  <div class="k-date-picker">
    <el-date-picker
      v-model="date"
      :type="type"
      class="picker"
      cellClassName="cell-class"
      :picker-options="pickerOptions"
      :disabled="isDisabled"
      :clearable="false"
      @change="onChange"
    >
    </el-date-picker>
    <div class="float-style" :class="{error: hasError, disabled: isDisabled}">
      <div class="date" :class="{placeholder: !showDate}">{{ showDate || placeholder || $t('common.requiredSelect') }}</div>
      <div class="icon" v-if="clearable && date" @click="handleClear">
        <KkIcon name="ic_calendar_line" size="sm" class="calendar-icon" />
        <img src="@/assets/icons/close-icon.svg" class="close-icon">
      </div>
      <div v-else>
        <KkIcon name="ic_calendar_line" size="sm" />
      </div>
    </div>
  </div>
</template>

<script>
import { KkIcon } from '@kkday/web-design-system'
import dayjs from 'dayjs'

export default {
  components: {
    KkIcon
  },
  props: {
    type: {
      type: String,
      default: 'date'
    },
    rangeSeparator: {
      type: String,
      default: '～'
    },
    value: {
      // v-model预设值，支持单日期和日期区间
      type: [String, Array],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    },
    pickerOptions: {
      type: Object,
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    splitter: {
      type: String,
      default: '/'
    }
  },
  watch: {
    value: {
      handler(val) {
        this.date = val
        let format = `YYYY${this.splitter}MM${this.splitter}DD`
        if (/month/.test(this.type)) {
          format = `YYYY${this.splitter}MM`
        } else if (/year/.test(this.type)) {
          format = 'YYYY'
        }
        if (!val) {
          this.showDate = ''
          return
        }
        if (Array.isArray(val)) {
          if (!val[0] && !val[1]) {
            this.showDate = ''
            return
          }
          this.showDate = `${dayjs(val[0]).format(format)} ${this.rangeSeparator} ${dayjs(val[1]).format(format)}`
        } else {
          if (!val) {
            this.showDate = ''
            return
          }
          this.showDate = dayjs(val).format(format)
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      date: this.value || null, // 初始值为预设值
      showDate: '',
      result: ''
    }
  },
  methods: {
    onChange(event) {
      let format = `YYYY${this.splitter}MM${this.splitter}DD`
      if (/month/.test(this.type)) {
        format = `YYYY${this.splitter}MM`
      } else if (/year/.test(this.type)) {
        format = 'YYYY'
      }
      if (Array.isArray(event)) {
        // 日期区间
        this.showDate = `${dayjs(event[0]).format(format)} ${this.rangeSeparator} ${dayjs(event[1]).format(format)}`
        this.result = [dayjs(event[0]).format(format), dayjs(event[1]).format(format)]
      } else {
        this.showDate = dayjs(event).format(format)
        this.result = this.showDate
      }
      this.$emit('input', this.result)
      this.$emit('change', this.result)
    },
    handleClear(event) {
      event.stopPropagation()
      this.date = null
      this.showDate = ''
      this.$emit('input', '')
      this.$emit('change', '')
    }
  }
}
</script>

<style lang="less" scoped>
.k-date-picker {
  position: relative;
  .float-style {
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: var(--kk-color-text-darker);
    background: #fff;
    border: 1px solid var(--kk-color-background-surface-dark);
    border-radius: var(--kk-radius-md);
    padding: 14px var(--kk-spacing-4);
    box-sizing: border-box;
    cursor: pointer;
    .icon {
      margin-left: var(--kk-spacing-3);
      position: relative;
      .calendar-icon {
        opacity: 1;
      }
      .close-icon {
        position: absolute;
        width: 20px;
        height: 20px;
        right: 0;
        top: 0;
        opacity: 0;
      }
    }
  }
  .disabled {
    border: 1px solid #E6E9ED !important;
    color: #BABBBE !important;
    background-color: #F1F4F8 !important;
  }
  .placeholder {
    color: var(--kk-color-text-light);
  }
  .picker {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    opacity: 0;
    width: 100%;
    cursor: pointer;
    height: 48px;
    &:hover~.float-style {
      border-color: var(--kk-color-text-darker);
    }
  }
  &:hover {
    .calendar-icon {
      opacity: 0 !important;
    }
    .close-icon {
      z-index: 10;
      opacity: 1 !important;
    }
  }
}
.el-input__inner {
  height: 48px;
}
.error {
  border-color: var(--kk-color-text-critical-dark) !important;
}
</style>
